import { fetchData, apiURL } from "../api-helper";

const getLayouts = () =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/layout/sector`;
    fetchData(endpointURL, "get")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const createLayout = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/layout/sector`;
    fetchData(endpointURL, "post", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const updateLayout = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/layout/sector/${payload.layoutId}`;
    fetchData(endpointURL, "put", payload.body)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const deleteLayout = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/layout/sector/${payload}`;
    fetchData(endpointURL, "delete")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getPartnerSectors = (payload) => 
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/sectors`;
    fetchData(endpointURL, "get", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const uploadImageToLayout = (payload) => 
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/layout/sector/${payload.get('layoutId')}/image`;
    fetchData(endpointURL, "postform", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getImageForLayout = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/api/layout/sector/${payload}/image`;
    fetchData(endpointURL, "get")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const createRelationSectorToLayout = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/sector`;
    fetchData(endpointURL, "post", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const deleteRelationSectorToLayout = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/sector?sector_id=${payload.sectorId}&layout_sector_id=${payload.layoutId}`;
    fetchData(endpointURL, "delete")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getLayoutData = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/layout/sector/${payload}`;
    fetchData(endpointURL, "get")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const uploadImageToSeat = (payload) => 
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/layout/seat/${payload.get('seatId')}/image`;
    fetchData(endpointURL, "postform", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getImageForSeat = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/api/layout/seat/${payload}/image`;
    fetchData(endpointURL, "get")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const createSeatLayout = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/layout/seat`;
    fetchData(endpointURL, "post", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

// const getSeatLayout = (payload) =>
//   new Promise((resolve, reject) => {
//     const endpointURL = `${apiURL}/admin/layout/seat`;
//     fetchData(endpointURL, "get", payload)
//       .then((result) => {
//         resolve(result);
//       })
//       .catch((error) => {
//         reject(error);
//       });
//   });


const getSeatsForLayout = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/sectors/${payload}/seats`;
    fetchData(endpointURL, "get")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const updateSeatLayout = ( payload ) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/layout/seat/${payload.layoutId}`;
    fetchData(endpointURL, "put", payload.body)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const createRelationSeatToLayout = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/seat`;
    fetchData(endpointURL, "post", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const deleteRelationSeatToLayout = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/seat?seat_id=${payload.seat_id}&layout_seat_id=${payload.layout_seat_id}`;
    fetchData(endpointURL, "delete")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const getPartnersForLayouts = () => 
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/partners/select`;
    fetchData(endpointURL, "get")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

export default {
  getLayouts,
  createLayout,
  updateLayout,
  deleteLayout,
  getPartnerSectors,
  uploadImageToLayout,
  getImageForLayout,
  createRelationSectorToLayout,
  deleteRelationSectorToLayout,
  getLayoutData,
  uploadImageToSeat,
  getImageForSeat,
  createSeatLayout,
  // getSeatLayout,
  getSeatsForLayout,
  updateSeatLayout,
  createRelationSeatToLayout,
  deleteRelationSeatToLayout,
  getPartnersForLayouts,
};
